"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e=require("../../../node_modules/graphql-tag/lib/index.js").gql`
    mutation markContentIncomplete(
        $contentTag: String
        $lotNumber: String
        $plannerType: String
    ) {
        markContentIncomplete(
            input: {
                contentTag: $contentTag
                lotNumber: $lotNumber
                plannerType: $plannerType
            }
        ) {
            clientMutationId
        }
    }
`;exports.markContentIncomplete=e;
//# sourceMappingURL=queries.js.map
